import { render, staticRenderFns } from "./HitDetail.vue?vue&type=template&id=61387ccf"
import script from "./HitDetail.vue?vue&type=script&lang=js"
export * from "./HitDetail.vue?vue&type=script&lang=js"
import style0 from "./HitDetail.vue?vue&type=style&index=0&id=61387ccf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports